
import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom'
import {isMobile} from 'react-device-detect';

import { client } from '../../client';




class FilterSection extends Component {
    // use a constructor if necessary
    constructor(props) {
      super(props);
     
      this.state = {
        value: ""
      };

      this.onChange = e => {
        this.setState({value : e.target.value});
      }
  



      // This binding is necessary to make `this` work in the callback
      // this.handleHover = this.handleHover.bind(this);
      // this.handleClick = this.handleClick.bind(this);
    }
  
    // handleHover = () => this.setState({ isToggled: !this.state.isToggled });


    
  render() {
    const {value} = this.state;
    return <div aria-label="Categories of work" className="flex justify-content-center column-gap-s h-9 phone-h-15 items-center bb wrap content-center row-gap-s">
          

          

          <Link to="../filter/kuratering" className={` flex height-fit ba br-100 bg  ${this.props.category == "KURATERING" ? "bg-hover" : ""} `}>    
            <label className="pt-xs pr-s pb-xs pl-s">KURATERING</label>
          </Link>

          <Link to="../filter/vaerker" className={` flex height-fit ba br-100 bg  left-50  ${this.props.category == "VÆRKER OG UDSTILLINGER" ? "bg-hover" : ""} `}>    
            <label className="pt-xs pr-s pb-xs pl-s">VÆRKER OG UDSTILLINGER</label>
          </Link>

          <Link to="../filter/nyheder" className={` flex height-fit ba br-100 bg  left-50  ${this.props.category == "NYHEDER" ? "bg-hover" : ""} `}>    
            <label className="pt-xs pr-s pb-xs pl-s">NYHEDER</label>
          </Link>


        
    </div>
    
  
  }
}

export default FilterSection;


          // {/* <ChipToggle linkTo="../filter/vaerker" content={this.props.firstChip} cx="margin-r-s margin-l-s" />
          // <ChipToggle linkTo="../filter/kuratering" content={this.props.secondChip} cx="margin-r-s margin-l-s" />
          // <ChipToggle linkTo="../filter/nyheder" content={this.props.thirdChip} cx="margin-r-s margin-l-s" /> */}


          // {/* <Link to="../filter/vaerker" className={` flex height-fit ba br-100 bg center-absolute left-50  ${this.state.isToggled == "værker" ? "bg-hover" : ""} `} onClick={this.handleHover}>    
          //     <label className="pt-xs pr-s pb-xs pl-s">VÆRKER OG UDSTILLINGER</label>
          // </Link> */}

          // {/* <Link to="../filter/kuratering" className={` flex height-fit ba br-100 bg center-absolute left-50  ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={isMobile ? null : this.handleHover} onMouseLeave={isMobile ? null : this.handleHover} onFocus={isMobile ? this.handleHover : null }>    
          //     <label className="pt-xs pr-s pb-xs pl-s">KURATERING</label>
          // </Link> */}

          // {/* <Link to="../filter/nyheder" className={` flex height-fit ba br-100 bg center-absolute left-50  ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={isMobile ? null : this.handleHover} onMouseLeave={isMobile ? null : this.handleHover} onFocus={isMobile ? this.handleHover : null }>    
          //     <label className="pt-xs pr-s pb-xs pl-s">NYHEDER</label>
          // </Link> */}


          // {/* 
          // <Chip linkTo="../filter/vaerker" content={this.props.firstChip} cx="margin-r-s margin-l-s" />
          // <Chip linkTo="../filter/kuratering" content={this.props.secondChip} cx="margin-r-s margin-l-s" />
          // <Chip linkTo="../filter/nyheder" content={this.props.thirdChip} cx="margin-r-s margin-l-s" /> */}
          
          
          // {/* <Chip content="aquarel" cx="margin-r-s margin-l-s" />
          // <Chip content="drawing" cx="margin-r-s margin-l-s" /> */}

      //     <form>
            
      //     <label>VÆRKER OG UDSTILLINGER
      //     <Link to="../filter/vaerker" className={`${value == "værker" ? "bg-hover" : null}`}> 
      //         <input  type="radio"
      //                 value="værker"
      //                 checked={value === "værker"}
      //                 onChange={this.onChange}/>
      //     </Link>
      //     </label>
        

        
          
      //     <Link to="../filter/kuratering" className={`${value == "kuratering" ? "bg-hover" : null}`}>
      //         <input  type="radio"
      //                 value="kuratering"
      //                 checked={value === "kuratering"}
      //                 onChange={this.onChange}/>
      //         KURATERING        
      //     </Link>
          
        
      
      // </form>